/** @format */

import React from "react";
import PropTypes from "prop-types";
export default function GoogleAd(props) {
  React.useEffect(() => {
    // window.onload = function () {
    // console.log("caleeddsssssssssss");
    //   (window.adsbygoogle = window.adsbygoogle || []).push({});
    // };
    // window.addEventListener("load", function () {
    //   console.log("caleed");
    //   (window.adsbygoogle = window.adsbygoogle || []).push({});
    // });
    if (process.env.NODE_ENV === "development") return;
    setTimeout(function () {
      if (window) (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, 200);
  }, []);

  return (
    <ins
      className={props.className + "   adsbygoogle  m-auto"}
      style={props.style}
      data-ad-format={props.format}
      data-full-width-responsive={props.responsive}
      data-ad-layout-key={props.layoutKey}
      data-ad-client="ca-pub-xxxxxxxxxxxxx"
      data-ad-slot={props.slot}
    ></ins>
  );
}
GoogleAd.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object, // eslint-disable-line
  slot: PropTypes.string.isRequired,
  layout: PropTypes.string,
  layoutKey: PropTypes.string,
  format: PropTypes.string,
  responsive: PropTypes.string,
};

GoogleAd.defaultProps = {
  className: "ads_responsive",
  style: { display: "block" },
  format: "auto",
  layout: "",
  layoutKey: "",
  responsive: "true",
};
